let Quote = require('../Managers/Quote');

module.exports = {
    _get: function(key) {
        let t = window.localStorage.getItem(key);
        if (t === undefined) {
            return null;
        }
        return JSON.parse(t);
    },
    getJPK: function() {
        let j = this._get('jpk');
        if (j !== undefined && j !== null) {
            return j;
        } else {
            return 0;
        }
    },
    getSPK: function() {
        let s = this._get('spk');
        if (s !== undefined && s !== null) {
            return s;
        } else {
            return 0;
        }
    },
    setJPK: function(value) {
        window.localStorage.setItem('jpk', JSON.stringify(value));
    },
    setSPK: function(value) {
        window.localStorage.setItem('spk', JSON.stringify(value));
    },
    getJourneyPermutation: function(){
        return parseInt(this.getJPK('jpk'))+parseInt(this.getSPK('spk'));
    },

    /**
     * Add the JPK to the SPK to establish if the user is on the fatter journey.
     * @returns {boolean}
     */
    isNotRentGuaranteeOrLegal: function() {
        let a = this.getJPK();
        let b = this.getSPK();
        return ((a + b) !== 16 || (a + b) !== 32);
    },

    /**
     * Add the JPK to the SPK to establish if the user is on the thinner journey.
     * @returns {boolean}
     */
    hasRentGuaranteeOrLegal: function() {
        let a = this.getJPK();
        let b = this.getSPK();
        return ((a + b) === 16 || (a + b) === 32);
    },

    setCovers: function(jpk, spk) {
        let j = jpk;
        let s = spk;
        // Set Buildings Cover
        if ((j === 2 || j === 4) || (s === 2 || s === 4)) {
            Quote.set('need_building_insurance', 'yes');
        } else {
            Quote.set('need_building_insurance', 'no');
        }

        //Set Contents Cover
        if ((j === 2 || j === 8) || (s === 2 || s === 8)) {
            Quote.set('need_contents_insurance', 'yes');
        } else {
            Quote.set('need_contents_insurance', 'no');
        }

        // Set Rent Gaurantee
        if (j === 16) {
            Quote.set('need_prestige_rent_guarantee', 'yes');
        } else {
            Quote.set('need_prestige_rent_guarantee', 'no');
        }

        // Set Legal Expenses
        if (j === 16 || j === 32) {
            Quote.set('need_legal_expenses', 'yes');
        } else {
            Quote.set('need_legal_expenses', 'no');
        }
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/ProductCover.js
 **/